import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/pep/HappyFaceWinkingThumbsUp.png'


const _hoisted_1 = {
  key: 0,
  "cy-data": "mobile-rewards-header"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MiniGuestRewardsBanner = _resolveComponent("MiniGuestRewardsBanner")!
  const _component_MiniRewardsBanner = _resolveComponent("MiniRewardsBanner")!
  const _component_HomePagePromo = _resolveComponent("HomePagePromo")!
  const _component_ScrollOrderHistory = _resolveComponent("ScrollOrderHistory")!
  const _component_GuestRewardsBanner = _resolveComponent("GuestRewardsBanner")!
  const _component_RewardsBanner = _resolveComponent("RewardsBanner")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_StartYourOrderBanner = _resolveComponent("StartYourOrderBanner")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_modalWrapper = _resolveComponent("modalWrapper")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, { "cy-data": "home-page-header" }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          (_ctx.isMobile)
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                (!_ctx.isLoggedIn)
                  ? (_openBlock(), _createBlock(_component_MiniGuestRewardsBanner, { key: 0 }))
                  : _createCommentVNode("", true),
                (_ctx.isLoggedIn)
                  ? (_openBlock(), _createBlock(_component_MiniRewardsBanner, { key: 1 }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_HomePagePromo, {
            promo: _ctx.mainPromo,
            id: "first-promo"
          }, null, 8, ["promo"]),
          (_ctx.isMobile)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                (_ctx.isLoggedIn && _ctx.hasOrderHistory)
                  ? (_openBlock(), _createBlock(_component_ScrollOrderHistory, { key: 0 }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isMobile)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                (!_ctx.isLoggedIn)
                  ? (_openBlock(), _createBlock(_component_GuestRewardsBanner, { key: 0 }))
                  : _createCommentVNode("", true),
                (_ctx.isLoggedIn)
                  ? (_openBlock(), _createBlock(_component_RewardsBanner, { key: 1 }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.promos.slice(1), (promo, idx) => {
            return (_openBlock(), _createBlock(_component_HomePagePromo, {
              key: idx,
              promo: promo
            }, null, 8, ["promo"]))
          }), 128)),
          _createVNode(_component_Footer)
        ]),
        _: 1
      }),
      (!_ctx.isNative)
        ? (_openBlock(), _createBlock(_component_StartYourOrderBanner, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(_component_modalWrapper, {
        maxHeight: "433px",
        height: "450px",
        maxWidth: "310px",
        minHeight: "439px",
        canDismiss: true,
        open: _ctx.state.modalOpen,
        hideToolbar: true,
        onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.state.modalOpen = false)),
        onDismiss: _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.modalOpen = false)),
        class: "d-none-web"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_row, { class: "full-width border-red" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, { class: "full-width text-center px-m8" }, {
                default: _withCtx(() => [
                  _cache[3] || (_cache[3] = _createElementVNode("img", {
                    src: _imports_0,
                    alt: "",
                    style: {"height":"170px","width":"170px"}
                  }, null, -1)),
                  _cache[4] || (_cache[4] = _createElementVNode("h1", { class: "margin-top-0" }, "Please update your app to continue...", -1)),
                  _createVNode(_component_ion_button, {
                    class: "mobile-update",
                    onClick: _ctx.openAppStore
                  }, {
                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                      _createTextVNode("OK")
                    ])),
                    _: 1
                  }, 8, ["onClick"]),
                  _cache[5] || (_cache[5] = _createElementVNode("p", { class: "font-size-14" }, [
                    _createTextVNode(" The latest version of our app features "),
                    _createElementVNode("br"),
                    _createTextVNode(" improvements no app user can live without. ")
                  ], -1)),
                  _cache[6] || (_cache[6] = _createElementVNode("p", { class: "font-size-14" }, [
                    _createTextVNode("Can't update now? Switch to "),
                    _createElementVNode("a", {
                      href: "https://www.donatos.com",
                      style: {"color":"#ad1b29"}
                    }, "donatos.com")
                  ], -1))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["open"])
    ]),
    _: 1
  }))
}